// Generated by CoffeeScript 2.7.0
var Alert, Alertify, alertify_instance;

Alert = {
  props: {
    message: String,
    options: Object
  },
  data: function() {
    return {
      type: '',
      description: '',
      duration: 5000,
      textButton: '',
      closable: true,
      showButtons: false,
      ensureText: '确认',
      cancelText: '取消',
      opened: true,
      _timer: null
    };
  },
  template: `<transition name="slide">
  <div class="alert"
        v-if="opened"
        @animationend="remove"
        @mouseover="_removeTimer"
        @mouseleave="_bindTimer"
        @click="selfClick">
    <div class="alert-content">
      <div class="left">
        <i v-if="type" :class="[iconClass, typeClass]"></i>
        <div class="message">
          <span>{{ message }}</span>
          <div v-if="description" class="description">{{ description }}</div>
        </div>
      </div>
      <button v-if="textButton" class="btn text-btn" @click="textBtnClick">{{ textButton }}</button>
    </div>
    <div v-if="showButtons" class="alert-footer">
      <button class="btn btn-small" @click="ensureClick">{{ ensureText }}</button>
      <button class="btn btn-default outlined btn-small" @click="cancelClick">{{ cancelText }}</button>
    </div>
  </div>
</transition>`,
  created: function() {
    _.extend(this, this.options);
    return this._bindTimer();
  },
  computed: {
    iconClass: function() {
      switch (this.type) {
        case 'success':
          return 'slp-check-circle';
        case 'error':
          return 'slp-times-circle';
      }
    },
    typeClass: function() {
      return `alert-${this.type}`;
    }
  },
  methods: {
    _removeTimer: function(event) {
      return clearTimeout(this._timer);
    },
    _bindTimer: function() {
      return this._timer = _.delay(this.close, this.duration);
    },
    close: function() {
      var base;
      this.opened = false;
      return typeof (base = this.options).closeCallback === "function" ? base.closeCallback() : void 0;
    },
    remove: function() {
      if (!this.opened) {
        return this.$emit('remove');
      }
    },
    selfClick: function() {
      if (this.closable) {
        return this.close();
      }
    },
    textBtnClick: function() {
      var base;
      return typeof (base = this.options).textButtonCallback === "function" ? base.textButtonCallback() : void 0;
    },
    ensureClick: function() {
      var base;
      return typeof (base = this.options).ensureCallback === "function" ? base.ensureCallback() : void 0;
    },
    cancelClick: function() {
      var base;
      return typeof (base = this.options).cancelCallback === "function" ? base.cancelCallback() : void 0;
    }
  }
};

Alertify = Vue.extend({
  components: {
    'alert-item': Alert
  },
  data: function() {
    return {
      queue: [],
      maxQueueCounts: 6
    };
  },
  template: `<div class="alert-log">
  <alert-item v-for="item in showQueue"
              :key="item.id"
              :message="item.message"
              :options="item.options"
              @remove="removeFunc(item)"></alert-item>
</div>`,
  computed: {
    showQueue: function() {
      return this.queue.slice(0, this.maxQueueCounts);
    }
  },
  methods: {
    addAlertItem: function(item) {
      return this.queue.push(item);
    },
    removeFunc: function(item) {
      var index;
      index = _.indexOf(this.queue, item);
      return this.queue.splice(index, 1);
    }
  }
});

alertify_instance = null;

export var newAlertify = function(message, options = {}) {
  if (!DomMaster.find('.alert-log').node) {
    alertify_instance = new Alertify({
      el: Skylark.Helpers.Utilities.getOrCreateElementById('alertify')
    });
  }
  alertify_instance.addAlertItem({
    id: Skylark.Helpers.Utilities.uuid(),
    message: message,
    options: options
  });
  return alertify_instance;
};
